import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import ChangePassword from './components/ChangePassword';
import AddEmployee from './components/AddEmployee';
import './css/argon.min.css';
import './css/index.css';
import './css/argon-dashboard.min.css';
import * as serviceWorker from './serviceWorker';
import { ConfirmDialogProvider } from './components/common/ConfirmDialogProvide';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import { Toaster } from 'react-hot-toast';
import installDeferredResizeObserver from './utils/installDeferredResizeObserver';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';

installDeferredResizeObserver();

ReactDOM.render(
  <ConfirmDialogProvider>
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      gutter={8}
      containerStyle={{ zIndex: 99999 }}
      toastOptions={{
        duration: 3000,
        success: {
          style: {
            background: '#36c95e',
            color: '#fff'
          }
        },
        error: {
          style: {
            background: '#f5251d',
            color: '#fff'
          }
        }
      }}
    />
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/register" component={AddEmployee} />
        <PrivateRoute exact path="/changePassword" component={ChangePassword} />
        <PrivateRoute exact path="/Home" component={Home} />
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute exact path="" component={Home} />
      </Switch>
    </Router>
  </ConfirmDialogProvider>,
  // eslint-disable-next-line no-undef
  document.getElementById('root')
);

// eslint-disable-next-line react/prop-types
function PrivateRoute({ component: Component, ...rest }) {
  // eslint-disable-next-line no-undef
  const loginTime = parseInt(localStorage.getItem('loginTime'));
  // eslint-disable-next-line no-undef
  const token = localStorage.getItem('token');

  let sessionValid = false;

  if (token && loginTime) {
    const now = Date.now();
    const diffInHours = (now - loginTime) / (1000 * 60 * 60); // hours

    // e.g. session valid for 8 hours
    if (diffInHours < 8) {
      sessionValid = true;
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        sessionValid ? (
          <Component {...props} />
        ) : (
          // eslint-disable-next-line react/prop-types
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
